import { render } from "./PersonaItemCard.vue?vue&type=template&id=6ddde23c&scoped=true"
import script from "./PersonaItemCard.vue?vue&type=script&lang=js"
export * from "./PersonaItemCard.vue?vue&type=script&lang=js"

import "./PersonaItemCard.vue?vue&type=style&index=0&id=6ddde23c&scoped=true&lang=css"

import exportComponent from "/home/PersonaExplorer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddde23c"]])

export default __exports__